
























































































































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { DataModules } from "@/store/modules/data";
import { IFraudEvent } from "@/models/fraud";
import { IOrder } from "@/models/orders";
import { mapState } from "vuex";
import { IState } from "@/store";
import Context from "@/mixins/context";

@Component({
  components: {
    "custom-fields-view": () =>
      import("@/components/app/global/customFields/customFieldsView.vue"),
    "download-invoice-cta": () =>
      import("@/components/app/global/invoices/downloadInvoiceCta.vue"),
    "fraud-provider": () =>
      import("@/components/app/global/fraud/fraudProvider.vue"),
    "fraud-status": () =>
      import("@/components/app/global/fraud/fraudStatus.vue")
  },
  computed: {
    ...mapState({
      user: (state: IState) => state.user
    })
  }
})
export default class OrderDetails extends Mixins(Context) {
  // Props

  @Prop({ required: true })
  public order!: IOrder;

  @Prop({ default: [] })
  public omit!: string[];

  // Getters

  public get isLoading() {
    return this.$_.isEmpty(this.order);
  }
  public get isDue() {
    return this.$store.getters[`data/${DataModules.ORDERS}/isDue`](this.order);
  }

  public get isOverdue() {
    return this.$store.getters[`data/${DataModules.ORDERS}/isOverdue`](
      this.order
    );
  }

  public get referringClient() {
    return this.order?.account?.affiliate_referral?.affiliate_account?.account
      ?.client?.[0];
  }

  // Life-cycle methods

  public created() {
    this.$bus.$on(`new-fraud-event`, this.fraudEventListener);
  }

  public beforeDestroy() {
    this.$bus.$off(`new-fraud-event`, this.fraudEventListener);
  }

  // Methods

  public fraudEventListener(event: IFraudEvent) {
    if (event.client_id === this.order.client_id) {
      this.$emit("refresh");
    }
  }
}
